import React, { useEffect, useState } from "react";
import { RefreshCw, Sparkles, X } from "lucide-react";
import { applyUpdate, SW_UPDATE_EVENT } from "../lib/setupSW";

/** Sticky in-app toast that appears the moment a new service worker finishes
 *  installing. Tapping REFRESH activates the new SW and reloads the page,
 *  so PWA users get the latest version without uninstalling. */
export default function UpdatePrompt() {
    const [waiting, setWaiting] = useState(null);
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        const onAvailable = (e) => {
            setWaiting(e.detail);
            setDismissed(false);
        };
        window.addEventListener(SW_UPDATE_EVENT, onAvailable);
        return () => window.removeEventListener(SW_UPDATE_EVENT, onAvailable);
    }, []);

    if (!waiting || dismissed) return null;

    return (
        <div
            className="fixed left-3 right-3 z-[70] md:left-auto md:right-6 md:w-96"
            style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 76px)" }}
            data-testid="sw-update-prompt"
        >
            <div className="relative bg-[#0A0A0A] border border-[#FF9F0A]/50 px-4 py-3 shadow-2xl backdrop-blur" style={{ borderRadius: 2 }}>
                <button
                    onClick={() => setDismissed(true)}
                    aria-label="Dismiss"
                    className="absolute top-2 right-2 text-zinc-500 hover:text-white"
                    data-testid="sw-update-dismiss"
                >
                    <X size={14} />
                </button>
                <div className="flex items-center gap-3 pr-6">
                    <div className="w-9 h-9 bg-[#FF9F0A]/15 border border-[#FF9F0A]/40 flex items-center justify-center flex-shrink-0" style={{ borderRadius: 2 }}>
                        <Sparkles size={16} className="text-[#FF9F0A]" />
                    </div>
                    <div className="min-w-0 flex-1">
                        <div className="heading text-sm uppercase font-bold leading-tight">New Version Ready</div>
                        <div className="text-xs text-zinc-400 mt-0.5 leading-snug">Refresh to pick up the latest fixes.</div>
                    </div>
                    <button
                        onClick={() => applyUpdate(waiting)}
                        className="btn-blaze text-xs py-2 px-3 min-h-[40px] flex-shrink-0"
                        data-testid="sw-update-apply"
                    >
                        <RefreshCw size={12} /> REFRESH
                    </button>
                </div>
            </div>
        </div>
    );
}
